module.exports = __webpack_public_path__ + "static/media/carta_95.bf6ef528.jpg";